import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.window
import org.w3c.dom.HTMLElement

@JsExport
@StimulusController(targets = ["info"], values = TravelInfoController.Values::class)
class TravelInfoController(context: dynamic) : Controller(context) {

    object Values {
        val latitude: Double = 0.0
        val longitude: Double = 0.0
        val travelUrl: String = ""
    }

    private val infoEl    by infoTarget<HTMLElement>()
    private val latitude  by latitudeValue()
    private val longitude by longitudeValue()
    private val travelUrl by travelUrlValue()

    override fun connect() {
        if (travelUrl.isNotEmpty()) fetchTravelInfo()
    }

    private fun fetchTravelInfo() {
        val geo = window.navigator.asDynamic().geolocation ?: return
        geo.getCurrentPosition({ position: dynamic ->
            val originLat = position.coords.latitude as Double
            val originLng = position.coords.longitude as Double
            val url = "$travelUrl?originLat=$originLat&originLng=$originLng&destLat=$latitude&destLng=$longitude"
            val p = window.asDynamic().fetch(url)
            p.then { r: dynamic -> if (r.ok as Boolean) r.json() else null }
             .then { data: dynamic ->
                 if (data != null) renderTravelInfo(data)
                 null
             }
             .catch { err: dynamic ->
                 console.error("Travel info fetch failed", err)
                 null
             }
        })
    }

    private fun renderTravelInfo(data: dynamic) {
        val modes = data.modes ?: return
        val length = (modes.length as? Double)?.toInt() ?: return
        val modeIcons = mapOf("walking" to "🚶", "transit" to "🚌", "driving" to "🚗")

        val parts = mutableListOf<String>()
        for (i in 0 until length) {
            val mode = modes[i]
            val modeName = mode.mode as? String ?: continue
            val duration = mode.durationText as? String ?: continue
            val icon = modeIcons[modeName] ?: continue
            parts.add("$icon $duration")
        }

        if (parts.isNotEmpty()) {
            infoEl.textContent = parts.joinToString("  ·  ")
        }
    }
}
